<div class="dialog">
  <div class="dialog-header">
    <div>
      <div class="title">{{ title }}</div>
      <div class="subtitle">{{ subtitle }}</div>
    </div>

    <button mat-icon-button (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="content">
    <div class="section-title">Employee Details</div>

    <div class="row" *ngFor="let f of readonlyFields">
      <div class="label">{{ f.label }}</div>
      <div class="value">{{ f.value }}</div>
    </div>

    <div class="edit-section" *ngIf="allowEditing" [formGroup]="form">
      <div class="edit-grid">
        <mat-form-field appearance="outline">
          <mat-label>Employee Number/ID</mat-label>
          <input matInput formControlName="employeeNumber" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Employment Date</mat-label>
          <input matInput type="date" formControlName="employmentDate" />
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Birth Date</mat-label>
          <input matInput type="date" formControlName="birthDate" />
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="footer">
    <ng-container *ngIf="allowEditing; else doneButton">
      <button mat-stroked-button type="button" class="cancel-btn" (click)="close()">
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        class="done-btn"
        type="button"
        [disabled]="saveDisabled"
        (click)="save()"
      >
        Save Changes
      </button>
    </ng-container>

    <ng-template #doneButton>
      <button mat-raised-button color="primary" class="done-btn" type="button" (click)="close()">Done</button>
    </ng-template>
  </div>
</div>
